export default "__VITE_ASSET__c1aecd20__"